import { CardVariant } from './../../enums/card-variant.enum';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-base-card',
  templateUrl: './base-card.component.html',
  styleUrls: ['./base-card.component.scss'],
})
export class BaseCardComponent {
  @Input() variant: CardVariant = CardVariant.blank;
  @Input() selected = false;

  public get variantClass(): string {
    switch (this.variant) {
      case CardVariant.light:
        return 'border-2 te-border-gradient-light-r card-border-correction';
      case CardVariant.myDrive:
        return 'border-2 te-border-gradient-r card-border-correction';
      case CardVariant.blue:
        return 'border-2 border-blue-dark card-border-correction';
      case CardVariant.turquoise:
        return 'shadow-md';
      case CardVariant.blank:
      default:
        return 'shadow-md';
    }
  }
}
